<template>
  <!-- eslint-disable -->
  <div>
    <b-overlay variant="white" :show="showLoading" spinner-variant="primary" blur="0" opacity=".75" rounded="sm">
      <b-row>
        <b-col sm="6" lg="3">
          <b-card no-body class="px-1 py-05 shadow-sm">
            <b-form-group>
              <label for="start_date" class="fs-5 fw-semibold d-inline"> Fecha inicio </label>
              <flat-pickr id="start_date" v-model="startDate" class="form-control" />
            </b-form-group>
          </b-card>
        </b-col>
        <b-col sm="6" lg="3">
          <b-card no-body class="px-1 py-05 shadow-sm">
            <b-form-group>
              <label for="endDate" class="fs-5 fw-semibold d-inline"> Fecha Final </label>
              <flat-pickr id="endDate" v-model="endDate" class="form-control" />
            </b-form-group>
          </b-card>
        </b-col>
        <b-col sm="6" lg="3">
          <b-card no-body class="px-1 py-05 shadow-sm">
            <b-form-group label="Tienda Origen" label-for="storeOrigin">
              <v-select
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="locals"
                label="name"
                :reduce="(locals) => locals.id"
                input-id="storeOrigin"
                v-model="local"
              />
            </b-form-group>
          </b-card>
        </b-col>
        <b-col sm="6" lg="3">
          <b-card no-body class="px-1 py-05 shadow-sm">
            <b-form-group label="Acciones" label-for="actions" class="text-05">
              <div class="d-flex justify-content-around" id="actions">
                <b-button @click.prevent="searchReport" class="w-100" id="search" v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary">
                  <!-- <feather-icon icon="StarIcon" class="mr-50" /> -->
                  <span class="align-middle">Buscar</span>
                </b-button>
                <b-button class="w-100 ml-2" id="export" v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="success">
                  <!-- <feather-icon icon="StarIcon" class="mr-50" /> -->
                  <span class="align-middle">Excel</span>
                </b-button>
              </div>
            </b-form-group>
          </b-card>
        </b-col>
        <!-- <b-col sm="6" lg="2">
          <b-card no-body class="px-1 py-05 shadow-sm">
            <b-form-group label="Exportar" label-for="export">
              
            </b-form-group>
          </b-card>
        </b-col> -->
      </b-row>
      <!-- <venta-filters /> -->
      <b-card no-body>
        <b-card-header>
          <!-- title and subtitle -->
          <div>
            <b-card-sub-title class="mb-25"> Total </b-card-sub-title>
            <b-card-title class="font-weight-bolder"> S/. {{ totalAmount }} </b-card-title>
          </div>
          <!--/ title and subtitle -->

          <!-- datepicker -->
          <!-- <div class="d-flex align-items-center">
        <feather-icon
          icon="CalendarIcon"
          size="16"
        />
        <flat-pickr
          v-model="rangePicker"
          :config="{ mode: 'range'}"
          class="form-control flat-picker bg-transparent border-0 shadow-none"
          placeholder="YYYY-MM-DD"
        />
      </div> -->
          <!-- datepicker -->
        </b-card-header>
        <b-card-body>
          <vue-apex-charts ref="chartVenta" type="bar" height="350" :options="chartOptions" :series="series" />
          <b-table
            class="position-relative text-center mt-4"
            :hover="true"
            :items="records"
            responsive
            :fields="fields"
            show-empty
            empty-text="No existen"
            @sort-changed="sortChanged"
          >
            <!-- Column: Actions -->
            <template #cell(actions)="{ item, field: { key }, index }">
              <b-button @click.prevent="detail(item, index)" size="sm" class="" variant="info">
                <span>Detalle</span>
                <b-modal
                  :id="'modalDetalle_' + index"
                  :ref="'modalDetalle_' + index"
                  centered
                  :title="'DETALLES'"
                  ok-only
                  hide-footer
                  size="lg"
                >
                  <b-card-text>
                    <b-row>
                      <b-col cols="12">
                        <b-table
                          class="position-relative"
                          :hover="true"
                          :items="details"
                          responsive
                          :fields="fieldsDetail"
                          show-empty
                          empty-text="No existen"
                        >
                        </b-table>
                      </b-col>
                    </b-row>
                  </b-card-text>
                </b-modal>
              </b-button>
            </template>
          </b-table>
        </b-card-body>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
/* eslint-disable */
import { $themeColors } from '@themeConfig'
import VueApexCharts from 'vue-apexcharts'
import flatPickr from 'vue-flatpickr-component'
import ventaFilters from './ventaFilters.vue'
import StoreService from '@/services/StoresService'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import ReportService from '@/services/ReportsService'
export default {
  directives: {
    Ripple
  },
  components: {
    VueApexCharts,
    flatPickr,
    ventaFilters,
    vSelect
  },
  data() {
    return {
      showLoading: false,
      startDate: new Date(),
      endDate: new Date(),
      rangePicker: ['2019-05-01', '2019-05-10'],
      totalAmount: 0.0,
      records: [],
      details: [],
      fields: [
        //{ key: 'id', label: 'Nº', sortable: false },
        { key: 'local', label: 'Local', sortable: false },
        { key: 'amount', label: 'Monto de Ventas(S/.)', sortable: false },
        { key: 'actions', label: 'Acciones' }
      ],
      fieldsDetail: [
        { key: 'brand', label: 'Marca', sortable: false },
        { key: 'originalCode', label: 'Cod. Original', sortable: false },
        { key: 'alterCode', label: 'Cod. Alterno', sortable: false },
        { key: 'description', label: 'Descripción', sortable: false },
        { key: 'price', label: 'Precio', sortable: false },
        { key: 'qty', label: 'Cantidad', sortable: false }
      ],
      local: null,
      locals: [],
      arrayFilters: [],
      currentPage: 1,
      entries: [10, 20, 50, 100],
      showEntrie: 10,
      totalElements: 0,
      id: 0,
      sort: 'id',
      order: 'desc',
      series: [
        {
          data: []
        }
      ],
      chartOptions: {
        chart: {
          toolbar: {
            show: false
          }
        },
        colors: ['#FAC384','#E99B42','#E97C42','#E95442'],
        plotOptions: {
          bar: {
            vertical: true,
            barHeight: '30%',
            distributed: true
            // endingShape: 'rounded',
          }
        },
        grid: {
          xaxis: {
            lines: {
              show: false
            }
          }
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          categories: []
        },
        yaxis: {
          // opposite: isRtl,
        }
      }
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    cambioPagina(e) {
      this.currentPage = e
    },
    changeSizePage() {},
    sortChanged(data) {
      this.sort = data.sortBy
      if (data.sortDesc) {
        this.order = 'desc'
      } else this.order = 'asc'
    },
    async getData() {
      this.locals = []
      const resp = await StoreService.getStores('',this.$store)
      if (resp) {
        this.locals = resp.stores
        this.locals.unshift({
          id: 0,
          name: 'Todos'
        })
      }
    },
    async searchReport() {
      this.records = []
      if (this.local != null) {
        let url = ''
        if (this.local == 0) {
          url = '?reportType=sale'
        } else {
          url = '?store=' + this.local +'&reportType=purchase'
        }
        const respReport = await ReportService.reportLocal(url, this.$store)
        if (respReport.objectGraph.length != 0) {
          this.records = respReport.objectGraph
          for (let index = 0; index < respReport.objectGraph.length; index++) {
            const element = respReport.objectGraph[index]
            this.chartOptions.xaxis.categories[index] = element.local
            this.series[0].data[index] = element.amount
            this.totalAmount += element.amount
          }
        } else{
          this.chartOptions.xaxis.categories = []
          this.series[0].data = []
          this.totalAmount = 0
        }
        this.$refs.chartVenta.updateOptions(this.chartOptions)
        this.$refs.chartVenta.updateSeries(this.series)
      }
    },
    detail(item, rowIndex) {
      this.details = []
      console.log('item', item)
      console.log('rowIndex', rowIndex)
      if (item.content.length > 0) {
        this.$refs['modalDetalle_' + rowIndex].show()
        this.details = item.content
      }
    }
  }
}
</script>

<style lang="scss">
.bg-red {
  background-color: #b2a6a6;
  color: #fff;
}
.py-05 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.text-05 {
  font-size: 0.85rem;
}
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/vue-select.scss';
</style>
